import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toastErrorr } from "../../../Helper/ToastMessage";
import { BaseUrl } from "../../../Helper/BaseUrl";

export const AchievementChecklistSliceAPI = createAsyncThunk("AchievementChecklistSlice", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        T_KPIUploadDailyWorkID,
        M_AssetID,
        M_AssetTypeID,
        M_WorkTypeID,
        token,
        M_UserID,
        Flag,

    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url
    url = `${BaseUrl}/APKDashboard/Get_WEB_GD_T_KPIUploadDailyWork_ChecklistProgress_Wise_Employee_Popup_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&T_KPIUploadDailyWorkID=${T_KPIUploadDailyWorkID}&M_AssetID=${M_AssetID}&M_AssetTypeID=${M_AssetTypeID}&M_WorkTypeID=${M_WorkTypeID}&M_UserID=${M_UserID}&Language=English&Flag=${Flag}&From=1&To=99999`

    return fetch(url, requestOptions)

        .then((res) => res.json())

        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                // console.log(result.data.table)

                return result.data.table
            } else {
                return
            }
        })
        .catch((err) => {
            console.log("Error:", err)
            return err
        })

})

const AchievementChecklistSliceSlice = createSlice({
    name: "AchievementChecklistSlice",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(AchievementChecklistSliceAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(AchievementChecklistSliceAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(AchievementChecklistSliceAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const AchievementChecklistSliceSliceReducer = AchievementChecklistSliceSlice.reducer